import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["warning", "checkbox", "count", "total"]

  connect() {
    // On connect, apply filters based on checked checkboxes
    this.filter()
  }

  filter() {
    const selectedTypes = new Set(
      this.checkboxTargets
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.value)
    )

    let visibleCount = 0

    this.warningTargets.forEach((warning) => {
      const warningCode = warning.dataset.warningCode

      if (selectedTypes.has(warningCode)) {
        warning.classList.remove("hidden")
        visibleCount++
      } else {
        warning.classList.add("hidden")
      }
    })

    // Update the visible count display
    if (this.hasCountTarget) {
      this.countTarget.textContent = visibleCount
    }
  }

  toggleFilter(event) {
    event.preventDefault()
    this.filter()
  }
}

